import React from "react"
import AsyncSelect from "react-select/async"
import { useStore } from "../store"
import { useTheme } from "../theme"
import { displayDateRange } from "../utils/format"
import { getReactSelectStyles } from "./Styles"

export default function RegistrantSelect(props) {
  const { theme } = useTheme()
  const { searchClient } = useStore()

  const [searchResults, setSearchResults] = React.useState({})

  const searchIndex = React.useMemo(() => {
    return searchClient.initIndex("fbe_tours")
  }, [searchClient])

  return (
    <AsyncSelect
      {...props}
      {...getReactSelectStyles(theme)}
      isClearable={true}
      defaultOptions={true}
      loadOptions={async inputValue => {
        const searchResults = await searchIndex.search(inputValue)
        setSearchResults(searchResults)
        return searchResults.hits.map(hit => ({
          label: `${hit.title} ${
            hit.tour_dates
              ? `(${displayDateRange(
                  hit.tour_dates[0].start,
                  hit.tour_dates[0].end
                )})`
              : ``
          }`,
          value: hit.id
        }))
      }}
      onChange={option => {
        if (props.onChange) {
          if (option) {
            props.onChange(option.value)
          } else {
            props.onChange(null)
          }
        }
      }}
    />
  )
}
